<template>
    <div class="publication__editor">

        <div class="publication__editor-wrap  d-flex">
            <div class="publication__editor-item">
                <div class="publication__fieldset">
                    <div class="publication__fieldset-title">Заголовок</div>
                    <div class="publication__fieldset-input">
                        <input type="text" v-model="$v.name.$model" placeholder="Введите заголовок объявления">
                    </div>
                    <div class="text-danger" v-show="$v.name.$error">Неверное значение.</div>
                </div>
                <div class="publication__fieldset">
                    <div class="publication__fieldset-title">Адрес</div>
                    <div class="publication__fieldset-input">
                        <input type="text" v-model="$v.street_address.$model" placeholder="Введите название улицы">
                    </div>
                    <div class="text-danger" v-show="$v.street_address.$error">Неверное значение.</div>
                </div>
                <div class="publication__fieldset publication__fieldset--textarea-large">
                    <div class="publication__fieldset-title">Описание</div>
                    <div class="publication__fieldset-input">
                        <textarea v-model="$v.description.$model" placeholder="Введите общий текст для объявления"></textarea>
                    </div>
                    <div class="text-danger" v-show="$v.description.$error">Неверное значение.</div>
                </div>

                <div class="publication__fieldset">
                    <div class="publication__fieldset-title">Количество дней:</div>
                    <div class="publication__fieldset-row d-flex">
                        <div class="publication__fieldset-row-item">
                            <div class="publication__fieldset-input">
                                <input type="text" v-model="$v.min_duration.$model" placeholder="От">
                            </div>
                            <div class="text-danger" v-show="$v.min_duration.$error">Неверное значение.</div>
                        </div>
                        <div class="publication__fieldset-row-item">
                            <div class="publication__fieldset-input">
                                <input type="text" v-model="$v.max_duration.$model" placeholder="До">
                            </div>
                            <div class="text-danger" v-show="$v.max_duration.$error">Неверное значение.</div>
                        </div>
                    </div>

                </div>

            </div>
            <div class="publication__editor-item">

                <div class="publication__section-item">
                    <div class="publication__section-title">Тип передержки:</div>
                    <div class="publication__section-list d-flex">
                        <div class="publication__section-list-item" v-for="(value, key) in serverDictionary.types">
                            <label class="d-flex">
                                <input type="radio" v-model="$v.type.$model" :value="key">
                                <span class="circle"></span>
                                {{value}}
                            </label>
                        </div>
                    </div>

                    <div class="text-danger" v-if="$v.type.$error">Неверное значение.</div>

                </div>

                <div class="publication__section-item">
                    <div class="publication__section-title">Платно/бесплатно:</div>
                    <div class="publication__section-list d-flex">
                        <div class="publication__section-list-item" v-for="(value, key) in serverDictionary.charge_categories">
                            <label class="d-flex">
                                <input type="radio" v-model="$v.charge_category.$model" :value="key">
                                <span class="circle"></span>
                                {{value}}
                            </label>
                        </div>
                    </div>

                    <div class="text-danger" v-if="$v.charge_category.$error">Неверное значение.</div>

                </div>

                <div class="publication__section-item">
                    <div class="publication__section-title">Приём животных:</div>
                    <div class="publication__section-list d-flex">
                        <div class="publication__section-list-item" v-for="(value, key) in serverDictionary.reception_statuses">
                            <label class="d-flex">
                                <input type="radio" v-model="$v.reception_status.$model" :value="key">
                                <span class="circle"></span>
                                {{value}}
                            </label>
                        </div>
                    </div>

                    <div class="text-danger" v-if="$v.reception_status.$error">Неверное значение.</div>

                </div>

                <div class="publication__section-item">
                    <div class="publication__section-title">Показывать как:</div>
                    <div class="publication__section-list d-flex">
                        <div class="publication__section-list-item" v-for="(value, key) in serverDictionary.view_modes">
                            <label class="d-flex">
                                <input type="radio" v-model="$v.view_mode.$model" :value="key">
                                <span class="circle"></span>
                                {{value}}
                            </label>
                        </div>
                    </div>

                    <div class="text-danger" v-if="$v.view_mode.$error">Неверное значение.</div>

                </div>

                <div class="publication__section-item" v-if="petsCategories.length" >
                    <div class="publication__section-title">Категории животных:</div>
                    <div class="publication__section-list d-flex">
                        <div class="publication__section-list-item" v-for="category in petsCategories">
                            <label class="d-flex">
                                <input type="checkbox" v-model="$v.pet_categories.$model" :value="category.id">
                                <span class="square"></span>
                                {{category.name}}
                            </label>
                        </div>
                    </div>

                    <div class="text-danger" v-if="$v.pet_categories.$error">Неверное значение.</div>

                </div>

            </div>
        </div>

    </div>
</template>

<script>

import { required, maxLength, minLength, minValue } from 'vuelidate/lib/validators';
import StateMixin from "../mixins/StateMixin";

export default {
    name: "HomestaysForm",
    mixins: [ StateMixin ],
    props: ['server'],


    data(){
        return{
            petsCategories: []
        }
    },

    async mounted(){
        await this.getPetsCategories()
            .then(() => { this.$parent.handleSliderHeight() });
    },

    computed: {

        serverDictionary(){ return this.server.dictionaries },

        name: {
            get() { return this.GET_BY_KEY('name') },
            set( val ) {
                this.SET_BY_KEY({key: 'name', data: val})
            }
        },

        description: {
            get() { return this.GET_BY_KEY('description') },
            set( val ) {
                this.SET_BY_KEY({key: 'description', data: val})
            }
        },

        street_address: {
            get() { return this.GET_BY_KEY('street_address') },
            set( val ) {
                this.SET_BY_KEY({key: 'street_address', data: val})
            }
        },

        type: {
            get() { return this.GET_BY_KEY('type') },
            set( val ) {
                this.SET_BY_KEY({key: 'type', data: val})
            }
        },

        charge_category: {
            get() { return this.GET_BY_KEY('charge_category') },
            set( val ) {
                this.SET_BY_KEY({key: 'charge_category', data: val})
            }
        },

        reception_status: {
            get() { return this.GET_BY_KEY('reception_status') },
            set( val ) {
                this.SET_BY_KEY({key: 'reception_status', data: val})
            }
        },

        view_mode: {
            get() { return this.GET_BY_KEY('view_mode') },
            set( val ) {
                this.SET_BY_KEY({key: 'view_mode', data: val})
            }
        },

        pet_categories: {
            get() { return this.GET_BY_KEY('pet_categories') },
            set( val ) {
                this.SET_BY_KEY({key: 'pet_categories', data: val})
            }
        },

        min_duration: {
            get() { return this.GET_BY_KEY('min_duration') },
            set( val ) {
                this.SET_BY_KEY({key: 'min_duration', data: val})
            }
        },

        max_duration: {
            get() { return this.GET_BY_KEY('max_duration') },
            set( val ) {
                this.SET_BY_KEY({key: 'max_duration', data: val})
            }
        },


    },

    methods:{

        async getPetsCategories(){

            try{

                const { data: { success = false, data = [] } } = await axios.get( '/api/pets/categories' );

                if( success ) this.petsCategories = data;


            } catch ( _e ){

                console.log( _e );

            }

        },

        isValid(){
            this.$v.$touch();

            if( this.$v.$invalid ){
                this.$emit('parent-update', false );
                return false
            }

            this.$emit('parent-update', true )
            return true

        }
    },

    validations: {
        type:             { required },
        view_mode:        { required },
        charge_category:  { required },
        reception_status: { required },

        min_duration:     { required, minValue: minValue(1) },
        max_duration:     {
            custom: function (value) {

                if(value !== null && +value < +this.min_duration){

                    if(value === ''){
                        value = null
                        return true
                    }

                    return false
                }


                return true
            }
        },

        pet_categories:   { required, minLength: minLength(1) },
        name:             { required, maxLength: maxLength(256) },
        street_address:   { required, maxLength: maxLength(256) },
        description:      { required, maxLength: maxLength(1000) },
    }


}
</script>

<style scoped>

</style>
